import { InternSet } from "internmap";
export default function intersection(values) {
    var others = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        others[_i - 1] = arguments[_i];
    }
    values = new InternSet(values);
    others = others.map(set);
    out: for (var _a = 0, values_1 = values; _a < values_1.length; _a++) {
        var value = values_1[_a];
        for (var _b = 0, others_1 = others; _b < others_1.length; _b++) {
            var other = others_1[_b];
            if (!other.has(value)) {
                values["delete"](value);
                continue out;
            }
        }
    }
    return values;
}
function set(values) {
    return values instanceof InternSet ? values : new InternSet(values);
}
